import React from "react";
import "./index.scss";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";

const Table = ({ config }) => {
  const { t } = useTranslation();
  const header = _.get(config, "header", []);
  const collection = _.get(config, "collection", []);
  const showHeader = _.get(config, "showHeader", true);
  const transHeader = _.get(config, "transHeader", true);
  const hasSubHeaders = header.some((col) => col.subHeaders);

  return (
    <table className="table table-bordered mb-0">
      {showHeader && (
        <thead>
          <tr className="align-middle">
            {header.map((col, index) => (
              <th
                key={index}
                className="small text-center"
                colSpan={
                  col.subHeaders ? col.subHeaders.length : col.colSpan || 1
                }
                rowSpan={col.subHeaders ? 1 : col.rowSpan || 2}
              >
                {transHeader ? t(col.label) : col.label}
              </th>
            ))}
          </tr>
          {hasSubHeaders && (
            <tr className="align-middle">
              {header.map((col) =>
                col.subHeaders
                  ? col.subHeaders.map((sub, subIndex) => (
                      <th
                        key={`${col.label}-${subIndex}`}
                        className="small text-center"
                      >
                        {t(sub.label || sub)}
                      </th>
                    ))
                  : null
              )}
            </tr>
          )}
        </thead>
      )}
      <tbody>
        {collection.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {header.map((col, colIndex) => {
              if (col.subHeaders) {
                return col.subHeaders.map((sub, subIndex) => (
                  <td
                    key={`${colIndex}-${subIndex}`}
                    className={sub.className || ""}
                  >
                    {sub.render
                      ? sub.render(row, rowIndex)
                      : row[sub.key] ?? ""}
                  </td>
                ));
              }

              return (
                <td key={colIndex} className={col.className || ""}>
                  {col.render ? col.render(row, rowIndex) : row[col.key]}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
